import React, { useState, useEffect } from "react";
import ReactIdSwiper from "react-id-swiper";
import * as actions from "../Actions";
import ChildListOverlay from "../ChildListOverlay";
import "../Feed.css";

export default (props) => {
  // //console.log(props);
  var data = props.data;
  console.log("data in slideBaby===>", data);
  var eleRef = props.eleRef;
  var selectedChild = eleRef.state.selectedChild;
  console.log("selectedChild in slideBaby===>", selectedChild);
  var userAryConceive =
    eleRef.state.childProfileData &&
    eleRef.state.childProfileData.userArr &&
    eleRef.state.childProfileData.userArr.isTryingToConceive;
  // //console.log("userAryConceive====",userAryConceive)
  // Swiper instance
  const [swiper, updateSwiper] = useState(null);
  // Slides current index
  const [currentIndex, updateCurrentIndex] = useState(0);
  var elePagi = ".swiper-pagination";
  if (props.page == "home-banners") {
    elePagi = ".swiper-pagination.swiper-pagination-white";
  }
  var params = {};
  // Params definition
  props.page == "dr-carousel-unit";
  params = {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 0,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      480: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
      640: {
        slidesPerView: 1,
        spaceBetween: 0,
      },
    },
    getSwiper: updateSwiper, // Get swiper instance callback
  };

  // Manipulate swiper from outside
  const goNext = () => {
    if (swiper !== null) {
      swiper.slideNext();
    }
  };

  const goPrev = () => {
    if (swiper !== null) {
      swiper.slidePrev();
    }
  };

  // Add eventlisteners for swiper after initializing
  useEffect(() => {
    if (swiper !== null) {
      swiper.on("slideChange", () => {
        updateCurrentIndex(swiper.realIndex);
        // //console.log("currentIndex --",swiper.realIndex);
        // //console.log("data[0].childArr --- ",data.childArr[swiper.realIndex])
        props.eleRef.getLatestFeedByChild(data.childArr[swiper.realIndex]);
      });
    }

    return () => {
      if (swiper !== null) {
        swiper.off("slideChange", () => updateCurrentIndex(swiper.realIndex));
      }
    };
  }, [swiper]);

  return (
    <div>
      {selectedChild && Object.keys(selectedChild).length > 0 ? (
        <div>
          {!selectedChild.isExpecting && selectedChild.childId != "" && (
            <div>
              <div className="baby-slider-overlay-view">
                <div className="baby-slide-all-common baby_bg_image_background">
                  <div className="baby-section-overylay">
                    <div className="baby_name_title_disc B18_21">
                      <span className="username_txt">
                        {selectedChild.childName
                          ? selectedChild.childName
                          : "Your baby "}
                      </span>{" "}
                      is{" "}
                      <span>
                        {" "}
                        {selectedChild?.age?.year
                          ? selectedChild?.age?.year
                          : ""}{" "}
                      </span>{" "}
                      and {selectedChild?.age?.year ? " years &" : ""}{" "}
                      <span>
                        {" "}
                        {selectedChild.age?.month
                          ? selectedChild.age?.month
                          : ""}{" "}
                      </span>{" "}
                      {selectedChild.age?.month ? " months " : ""}{" "}
                      <span>
                        {!selectedChild?.age?.year && selectedChild.age?.days
                          ? selectedChild.age?.days
                          : ""}
                      </span>{" "}
                      {!selectedChild?.age?.year && selectedChild?.age?.days
                        ? " days"
                        : ""}{" "}
                      old
                    </div>
                    <div className="baby_details_dates_weight ">
                      <div className="left_baby_weight">
                        <div className="left_baby_weight_details-content">
                          <div className="baby_weight_details-content">
                            <div className="text_content_details">
                              <div className="text_ideal_details">
                                {" "}
                                Ideal height{" "}
                              </div>
                              <div className="dis_ideal_details">
                                {" "}
                                {selectedChild.height
                                  ? selectedChild.height
                                  : "0"}
                                cm{" "}
                              </div>
                            </div>
                          </div>
                          <div className="prof_detail_div"></div>
                          <div className="baby_weight_details-content baby_before_details">
                            <div className="text_content_details">
                              <div className="text_ideal_details">
                                {" "}
                                Ideal Weight{" "}
                              </div>
                              <div className="dis_ideal_details">
                                {" "}
                                {selectedChild.weight
                                  ? selectedChild.weight
                                  : "0"}
                                kg{" "}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="right_baby_profile">
                        <div className="baby_profile-images">
                          {selectedChild.childPhoto == "" ? (
                            <div>
                              {selectedChild?.age?.year == 0 ? (
                                <img
                                  className="no_babyImg dev_chld_prof"
                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/01-Infant.webp"
                                  title={selectedChild.childName}
                                  alt={selectedChild.childName}
                                  onClick={() => actions.openprofilePopup()}
                                />
                              ) : selectedChild?.age?.year < 2 ? (
                                <img
                                  className="no_babyImg dev_chld_prof"
                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/02-Baby.webp"
                                  title={selectedChild.childName}
                                  alt={selectedChild.childName}
                                  onClick={() => actions.openprofilePopup()}
                                />
                              ) : selectedChild?.age?.year < 4 ? (
                                <img
                                  className="no_babyImg dev_chld_prof"
                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/03-Toddler.webp"
                                  title={selectedChild.childName}
                                  alt={selectedChild.childName}
                                  onClick={() => actions.openprofilePopup()}
                                />
                              ) : (
                                <img
                                  className="no_babyImg dev_chld_prof"
                                  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/05-Big Kids.webp"
                                  title={selectedChild.childName}
                                  alt={selectedChild.childName}
                                  onClick={() => actions.openprofilePopup()}
                                />
                              )}
                            </div>
                          ) : (
                            <img
                              src={selectedChild.childPhoto}
                              alt={selectedChild.childName}
                              onClick={() => actions.openprofilePopup()}
                            />
                          )}
                        </div>
                        <span
                          className="icon"
                          data-icon-font="H"
                          onClick={() => actions.openprofilePopup()}
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <div className="baby-slider-overlay-view">
    <div className="baby-slide-all-common baby_bg_image_background"> 
      <div className="right_sidebar_ps_sidebar_ps">
         <div className="right_sidebar_dates_weight ">
              <div className="right_sidebar_ps_profile">
                  <div className="right_sidebar_ps_profile-images">
                  <img src={selectedChild.childPhoto?selectedChild.childPhoto:"../media/02-Baby.webp"} alt="logo" onClick={()=>actions.openprofilePopup()}/>                                </div>
              </div>
              <div className="baby_name_title_disc B20_21">
              {selectedChild.childName?selectedChild.childName:'Test'} is <span> {selectedChild.age?.year?selectedChild.age?.year:'0'} </span> years & <span> {selectedChild.age?.month?selectedChild.age?.month:'0'} </span> months <span>{selectedChild.age?.days?selectedChild.age?.days:'0'}</span> Days old                            </div>
              <div className="right_sidebar_ps_baby_weight">
                 <div className="right_sidebar_ps_details-content">
                   <div className="baby_weight_details-content">
                      <div className="text_content_details">
                         <div className="text_ideal_details M15_75"> Ideal Weight </div>
                         <div className="dis_ideal_details"> {selectedChild.weight?selectedChild.weight:'0'} kg </div>
                      </div>
                   </div>
                   <div className="baby_weight_details-content baby_before_details">
                     <div className="text_content_details">
                         <div className="text_ideal_details M15_75"> Ideal height </div>
                         <div className="dis_ideal_details">{selectedChild.height?selectedChild.height:'0'} Cm </div>
                      </div>
                   </div>
                </div>
              </div>
          </div> 
    </div>
    </div>
  </div> */}
            </div>
          )}

          {
            selectedChild.isExpecting == 1 &&
              !selectedChild.isTryingToConceive && (
                <div className="baby-slider-overlay-view prof_sec_wrap">
                  <div className="baby-slide-all-common baby_bg_image_background">
                    <div className="baby-section-overylay">
                      <div className="baby_name_title_disc B18_21">
                        <span className="username_txt">
                          {selectedChild.childName
                            ? selectedChild.childName
                            : global.userAry["userName"]}
                        </span>{" "}
                        <span>
                          {" "}
                          {selectedChild.currentWeek
                            ? selectedChild.currentWeek
                            : ""}{" "}
                        </span>{" "}
                        {selectedChild.currentWeek ? "weeks &" : ""}
                        <span>
                          {" "}
                          {selectedChild.age?.days
                            ? selectedChild.age?.days
                            : ""}{" "}
                        </span>{" "}
                        {selectedChild.age?.days ? "days " : ""}Pregnant
                      </div>
                      <div className="baby_details_dates_weight ">
                        <div className="right_baby_profile">
                          <div className="baby_profile-images">
                            <img
                              src={
                                selectedChild.childPhoto
                                  ? selectedChild.childPhoto
                                  : "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/06-Expecting.webp"
                              }
                              alt="logo"
                              onClick={() => actions.openprofilePopup()}
                            />
                          </div>
                          <span
                            className="icon"
                            data-icon-font="H"
                            onClick={() => actions.openprofilePopup()}
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="baby_in_comparision_to">
                    {eleRef.state.BabysizecomparisonSlider &&
                      eleRef.state.BabysizecomparisonSlider[0] &&
                      eleRef.state.BabysizecomparisonSlider[0].data[0]
                        .dataArray && (
                        <div>
                          <div className="baby_in_comparision_heading M14_42">
                            {
                              eleRef.state.BabysizecomparisonSlider[0].data[0]
                                .descriptionText
                            }
                          </div>

                          <div className="baby_in_comparision_mainview">
                            <div className="comparision_mainview_div">
                              <div className="comparision_mainview_div_pic">
                                <img
                                  src={
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.animalUrl
                                  }
                                  alt="logo"
                                />
                                <div className="bottom_comparision_mainview M12_white">
                                  {
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.animalName
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="comparision_mainview_div">
                              <div className="comparision_mainview_div_pic">
                                <img
                                  src={
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.fruitUrl
                                  }
                                  alt="logo"
                                />
                                <div className="bottom_comparision_mainview M12_white">
                                  {
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.fruitName
                                  }
                                </div>
                              </div>
                            </div>
                            <div className="comparision_mainview_div">
                              <div className="comparision_mainview_div_pic">
                                <img
                                  src={
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.sweetsUrl
                                  }
                                  alt="logo"
                                />
                                <div className="bottom_comparision_mainview M12_white">
                                  {
                                    eleRef.state.BabysizecomparisonSlider[0]
                                      .data[0].dataArray.sweetsName
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                  </div>
                </div>
              )
            //  <div className="baby-slider-overlay-view">
            //     <div className="baby-slide-all-common baby_bg_image_background">
            //       <div className="right_sidebar_ps_sidebar_ps">
            //          <div className="right_sidebar_dates_weight ">
            //               <div className="right_sidebar_ps_profile">
            //                   <div className="right_sidebar_ps_profile-images baby_circle_profile21">
            //                     <img src="../../../../images/06-Expecting.webp" alt="logo" onClick={()=>actions.openprofilePopup()}/>
            //                   </div>
            //               </div>
            //               <div className="baby_name_title_disc  baby_name_desktop_after B20_21">
            //               {selectedChild.childName?selectedChild.childName:global.userAry['userName']} <span> 23 </span> weeks & <span> 5 </span> Days Pregnant
            //               </div>

            //               <div className="baby_in_comparision_to">

            //               {eleRef.state.BabysizecomparisonSlider && eleRef.state.BabysizecomparisonSlider[0] && eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray &&
            //               <div>

            //               <div className="baby_in_comparision_heading M14_42">
            //                   {eleRef.state.BabysizecomparisonSlider[0].data[0].descriptionText}
            //               </div>

            //               <div className="baby_in_comparision_mainview">

            //                 <div className="comparision_mainview_div">
            //                     <div className="comparision_mainview_div_pic">
            //                     <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalUrl} alt="logo"/>
            //                     <div className="bottom_comparision_mainview M12_white">
            //                        {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.animalName}
            //                     </div>
            //                     </div>
            //                  </div>
            //                  <div className="comparision_mainview_div">
            //                     <div className="comparision_mainview_div_pic">
            //                     <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitUrl} alt="logo"/>
            //                     <div className="bottom_comparision_mainview M12_white">
            //                        {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.fruitName}
            //                     </div>
            //                     </div>
            //                  </div>
            //                  <div className="comparision_mainview_div">
            //                     <div className="comparision_mainview_div_pic">
            //                     <img src={eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsUrl} alt="logo"/>
            //                     <div className="bottom_comparision_mainview M12_white">
            //                        {eleRef.state.BabysizecomparisonSlider[0].data[0].dataArray.sweetsName}
            //                     </div>
            //                     </div>
            //                  </div>
            //               </div>
            //             </div>
            //               }
            //               </div>

            //           </div>
            //     </div>
            //     </div>
            //   </div>
          }
          {selectedChild.isTryingToConceive > 0 &&
            selectedChild.childId == "" && (
              <div>
                <div className="baby-slider-overlay-view prof_sec_wrap">
                  <div className="baby-slide-all-common baby_bg_image_background">
                    <div className="baby-section-overylay ttc">
                      <div className="baby_name_title_disc B18_21 try_conceive_heading">
                        <span className="username_txt">
                          {global.userAry["userName"]
                            ? global.userAry["userName"]
                            : ""}
                        </span>{" "}
                        <span>is Trying to Conceive</span>
                      </div>
                      <div className="baby_details_dates_weight try_conceive_profile">
                        <div className="right_baby_profile">
                          <div className="baby_profile-images">
                            <img
                              src={
                                selectedChild.childPhoto
                                  ? selectedChild.childPhoto
                                  : "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/07-Trying-to-concieve.webp"
                              }
                              alt="logo"
                              onClick={() => actions.openprofilePopup()}
                            />
                          </div>
                          <span
                            className="icon"
                            data-icon-font="H"
                            onClick={() => actions.openprofilePopup()}
                          ></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
        </div>
      ) : (
        <div>
          <div className="baby-slider-overlay-view">
            <div className="baby-slide-all-common baby_bg_image_background">
              <div className="right_sidebar_ps_sidebar_ps">
                <div className="right_sidebar_dates_weight ">
                  <div className="right_sidebar_ps_profile">
                    <div className="right_sidebar_ps_profile-images">
                      <a href="https://parenting.firstcry.com/my-account/myprofile">
                        <img
                          src={
                            data.userPic
                              ? data.userPic
                              : "https://cdn.cdnparenting.com/brainbees/community/preact/public/media/default-img.png"
                          }
                          alt="logo"
                        />
                      </a>{" "}
                    </div>
                  </div>
                  <div className="baby_name_title_disc B20_21">
                    <span className="username_txt">
                      {data.childName
                        ? data.childName
                        : global.userAry["userName"]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
    // <div>
    // {data.childArr ?
    // <div>
    //   <ReactIdSwiper {...params}>

    //     {data.childArr && data.childArr.map((item, idx) => (
    //       (props.page == "dr-carousel-unit" ?
    //         <div className="swiper-slide_feed " key={idx}>
    //           <div className="baby-slider-overlay-view">
    //               <div className="baby-slide-all-common baby_bg_image_background">
    //                   {item.isExpecting==0 &&
    //                     <div className="baby-section-overylay">
    //                         <div className="baby_name_title_disc B18_21">
    //                             {item['childName']?item['childName']:'Test'} is <span> {item['age']['year']?item['age']['year']:'0'} </span> years & <span> {item['age']['month']?item['age']['month']:'0'} </span> months <span>{item['age']['days']?item['age']['days']:'0'}</span> Days old
    //                         </div>
    //                         <div className="baby_details_dates_weight ">
    //                             <div className="left_baby_weight">
    //                                <div className="left_baby_weight_details-content">
    //                                  <div className="baby_weight_details-content">
    //                                     <div className="text_content_details">
    //                                        <div className="text_ideal_details"> Ideal height </div>
    //                                        <div className="dis_ideal_details"> {item['height']?item['height']:'0'} cm </div>
    //                                     </div>
    //                                  </div>
    //                                  <div className="baby_weight_details-content baby_before_details">
    //                                    <div className="text_content_details">
    //                                        <div className="text_ideal_details"> Ideal Weight </div>
    //                                        <div className="dis_ideal_details">  {item['weight']?item['weight']:'0'} kg </div>
    //                                     </div>
    //                                  </div>
    //                               </div>
    //                             </div>
    //                             <div className="right_baby_profile">
    //                                 <div className="baby_profile-images">
    //                                  <img src={item['childPhoto']?item['childPhoto']:"../../../../images/Baby Profile.webp"} alt="logo"/>
    //                                 </div>
    //                             </div>
    //                         </div>
    //                     </div>
    //                   }

    //                   {item.isExpecting==1  &&
    //                     <div className="baby-section-overylay">
    //                         <div className="baby_name_title_disc B18_21">
    //                             {data.childArr[0].childName?data.childArr[0].childName:global.userAry['userName']} <span> 23 </span> weeks & <span> 5 </span> Days Pregnant
    //                         </div>
    //                         <div className="baby_pregnent_dates_weight ">
    //                             <a href="#">
    //                             <img src="../../../../images/06-Expecting.webp" alt="logo"/>
    //                             </a>
    //                         </div>
    //                     </div>
    //                   }
    //               </div>

    //           </div>
    //         </div>
    //         :
    //         <div className="swiper-slide_feed" key={idx}>
    //           <img src="https://bbcdnlivemumbai.s3.ap-south-1.amazonaws.com/brainbees/community/memoryimages/1584339297p4706331.jpeg" />
    //         </div>
    //       )
    //     ))
    //   }
    //   </ReactIdSwiper>
    //   <div className="buttons baby-slide-buttons-list">
    //     <button id="prevSlide" className="button is-primary " onClick={goPrev}>
    //       <span data-icon-font="g" className="icon"></span>
    //     </button>
    //     <button id="nextSlide" className="button is-primary" onClick={goNext}>
    //       <span data-icon-font="h" className="icon"></span>
    //     </button>
    //   </div>
    // </div>
    // :
    // <div>
    //   <div className="baby-slider-overlay-view">
    //     <div className="baby-slide-all-common baby_bg_image_background">
    //       <div className="right_sidebar_ps_sidebar_ps">
    //          <div className="right_sidebar_dates_weight ">
    //               <div className="right_sidebar_ps_profile">
    //                   <div className="right_sidebar_ps_profile-images">
    //                   <a href="https://parenting.firstcry.com/my-account/myprofile">
    //                   <img src={data[0].userPic?data[0].userPic:"../../../../images/Baby Profile.webp"} alt="logo"/>
    //                   </a>                              </div>
    //               </div>
    //               <div className="baby_name_title_disc B20_21">
    //               {data[0].childName?data[0].childName:'../media/default-img.png'}
    //               </div>

    //           </div>
    //     </div>
    //     </div>
    //   </div>
    //   </div>
    // }
    // </div>
  );
};
